module.exports = __webpack_public_path__ + "img/upnewposter.be808c8a.svg";